import ApiService from "../api.service";
import appConfig from "../../../app-config";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const ManifestOrderService = {
  async saveManifestOrder(payload) {
    var url = "api/Save_ManifestOrder";
    await ApiService.post(url, payload);
  },
};

export { ManifestOrderService };
